import { Tooltip } from "antd";

const svgString = `
  <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1" width="34" height="34" rx="17" stroke="#08212D" stroke-width="1.2" />
    <path d="M13.5 14.875L9.75 18L13.5 21.125" stroke="#08212D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M23.5 14.875L27.25 18L23.5 21.125" stroke="#08212D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M21 11.125L16 24.875" stroke="#08212D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
`;

const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;

const CodeIcon = ({ onOpenSourceCode, content }) => {
  return (
    <Tooltip title="This placeholder will not be visible in the preview">
      <div className="code-icon">
        <button onClick={onOpenSourceCode}>
          <img
            src={svgDataUrl}
            alt="Code Icon"
            style={{ width: 46, height: 46 }} 
          />
        </button>
        <span>{content ? "Edit code" : "Add code"}</span>
      </div>
    </Tooltip>
  );
};

export default CodeIcon;